

























































































import { Vue, Component } from "vue-property-decorator";
import VueBase from "@/lib/vuebase";
import ajax from "@/lib/ajax";
import { Dialog } from "vant";
import app from "@/lib/app";
@Component({})
export default class BindSchoolView extends VueBase {
  onClickLeft() {
    window.history.go(-1);
  }
  cityName: string = "";
  cityShowPicker: boolean = false;
  sendCodeMsg: string = "发送验证码";
  btnIsDisabled: boolean = false;
  formstate: any = {
    userName: "",
    userPhone: "",
    mainPhone: "",
    vCode: "",
    schoolCode: "",
    schoolName: "",
    openId: "",
  };
  cityNames = ["无锡", "常州", "泰州", "徐州", "盐城","扬州","南通"];
  citys = [
    { cityName: "无锡", cityCode: "0510" },
    { cityName: "常州", cityCode: "0519" },
    { cityName: "泰州", cityCode: "0523" },
    { cityName: "徐州", cityCode: "0516" },
    { cityName: "盐城", cityCode: "0515" },
    { cityName: "扬州", cityCode: "0514" },
    { cityName: "南通", cityCode: "0513" },
  ];
  async cityOnConfirm(value: string) {
    this.cityName = value;
    this.cityShowPicker = false;
    await this.getSchoolList(this.cityName);
  }

  schoolName: string = "";
  schoolShowPicker: boolean = false;
  schoolNames: Array<any> = [];
  schools: any;
  schoolOnConfirm(value: string) {
    this.schoolName = value;
    this.schoolShowPicker = false;
  }
  async sendCode() {
    if (this.formstate.mainPhone == "") {
      Dialog({ message: "请输入驾校手机号" });
    } else {
      await ajax
        .get("MFA/MFAMainPhoneSendCode?phone=" + this.formstate.mainPhone)
        .then((rep) => {});
      this.btnIsDisabled = true;
      this.sendCodeMsg = "已发送";
    }
  }
  async onSubmit() {
    // this.$refs.van.validate().then(() => {});

    this.formstate.openId = app.getOpenId();
    this.formstate.schoolName = this.schoolName;
    this.schools.forEach((t: any) => {
      if (t.schoolName == this.schoolName)
        this.formstate.schoolCode = t.schoolCode;
    });
    await ajax.post("MFA/BindMFAUser", this.formstate).then((rep) => {
      if (rep.data.code == 1) {
        Dialog({ message: rep.data.message });
      } else {
        this.$router.push({ path: "/bindSchoolList" });
      }
    });
  }
  async getSchoolList(value: any) {
    let code = "";
    this.citys.forEach((t: any) => {
      if (t.cityName == value) code = t.cityCode;
    });
    this.formstate.cityCode = code;
    await ajax.get("MFA/GetSchoolList?cityCode=" + code).then((rep) => {
      this.schools = rep.data.result;
      this.schools.forEach((element: any) => {
        this.schoolNames.push(element.schoolName);
      });
    });
  }
  rules:any = {
    req: [{ required: true, message: "必填" }],
    mobile:[{ required: true, message: "必填" },{pattern: /^1[3-9]\d{9}$/, message:"手机号不正确"}]
  };
  onFailed(errorInfo: any) {
    console.log("failed", errorInfo);
  }
}
